/*
描述：模块可见性
日期：2017-8-2
作者：Bai.Zhiming
 */
'use strict';
angular.module('moduleVisibilityModule', ['moduleVisibilityHeightModule']).controller('moduleVisibilityCtrl', [
    '$scope',
    '$q',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    '$state',
    'permissionAssignmentService',
    function($scope, $q, $timeout, trsHttpService, modalDialog, $state, permissionAssignmentService) {
        initStatus();
        initData();

        /**
         * [initStatus ] 初始化状态
         * @return {[type]} [description] null
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = {
                planResources: [],
            };
            // 监控角色切换开始
        }
        $scope.$on('roleData', function(event, data) {
            $state.go('manageconfig.rolemanage.modulevisibility', '', { reload: 'manageconfig.rolemanage.modulevisibility' });
        });

        /**
         * [initStatus ] 初始化状态
         * @return {[type]} [description] null
         */
        function initData() {
            queryMlfModule($scope.roleData.ROLEID).then(function() {
                queryRightClassify($scope.data.manageModuleData[0].CLASSIFY);
            });
        }

        /**
         * [initStatus queryMlfModule] 获取模块
         * @param {string} [roleId] [description] 角色ID
         * @return {[type]} [description] null
         */
        function queryMlfModule(roleId) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_modal',
                methodname: 'queryMlfModal',
                RoleId: roleId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var commonModuleData = angular.copy(data);
                $scope.data.manageModuleData = commonModuleData.splice(4, 1);
                $scope.data.commonModuleData = commonModuleData;
                $scope.initGroupRight($scope.data.manageModuleData[0]);
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [ queryRightClassify] 查询模块权限列表
         * @return {[type]} [description] null
         */
        function queryRightClassify(classify) {
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'queryRightClassify',
                Classify: classify,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.structuredData = data; // 结构数据
            });
        }

        /**
         * [selectCommonModule ] 选择或取消普通模块的可见性
         * @param {obj} [item] [description] 模块信息
         * @return {[type]} [description] null
         */
        $scope.selectCommonModule = function(item) {
            checkCancel(item).then(function() {
                var rightValue = item.RIGHTVALUE.split('');
                rightValue[item.RIGHTINDEX - 1] = rightValue[item.RIGHTINDEX - 1] === '0' ? '1' : '0';
                item.RIGHTVALUE = rightValue.join('');
            });
        };

        /**
         * [checkCancel description] 校验是否可以取消
         * @param  {[type]} item [description] 权限信息
         * @return {[type]}      [description]
         */
        function checkCancel(item) {
            var deffer = $q.defer();
            var rightValue = item.RIGHTVALUE.split('');
            if (item.HASDISTRIBUTERIGHT === 'true' && rightValue[item.RIGHTINDEX - 1] === '1') {
                modalDialog.alertType(item.MODALNAME + '已配置过功能权限，确定要取消其模块可见性', '', 'ask', true, function() {
                    deffer.resolve();
                });
            } else {
                deffer.resolve();
            }
            return deffer.promise;
        }

        /**
         * [selectMCModule ] 选择或取消普通模块的可见性
         * @param {obj} [item] [description] 模块信息
         * @return {[type]} [description] null
         */
        $scope.selectMCModule = function(item) {
            checkMCCancel(item).then(function() {
                var rightValue = $scope.data.manageModuleData[0].RIGHTVALUE.split('');
                rightValue[item.RIGHTINDEX - 1] = rightValue[item.RIGHTINDEX - 1] === '0' ? '1' : '0';
                $scope.data.manageModuleData[0].RIGHTVALUE = rightValue.join('');
            });
        };

        /**
         * [checkMCCancel description] 检测管理配置的模块可见性是否能取消
         * @return {[type]} [description]
         */
        function checkMCCancel(item) {
            var deffer = $q.defer();
            var rightValue = $scope.data.manageModuleData[0].RIGHTVALUE.split('');
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'checkRightCanCancel',
                RoleId: $scope.roleData.ROLEID,
                OperKey: item.RIGHTVALUE,
                RightIndex: item.RIGHTINDEX,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (rightValue[item.RIGHTINDEX - 1] === '1' && data.ISSUCCESS !== 'true') {
                    modalDialog.alertType(item.MODALNAME + '已配置过功能权限，确定要取消其模块可见性', '', 'ask', true, function() {
                        deffer.resolve();
                    });
                } else {
                    deffer.resolve();
                }
            });
            return deffer.promise;
        }

        /**
         * [secondSelectAllChecked ] 二级全选检查
         * @param {obj} [items] [description] 基层权限组
         * @return {[type]} [description] null
         */
        $scope.secondSelectAllChecked = function(items) {
            var flag = true;
            for (var i = 0; i < items.CHILDREN.length; i++) {
                if ($scope.data.manageModuleData[0].RIGHTVALUE[items.CHILDREN[i].RIGHTINDEX - 1] === '0') {
                    flag = false;
                    break;
                }
            }
            items.isSelectedAll = flag;
            return flag;
        };

        /**
         * [secondSelectAll ]二级全选
         * @param {obj} [items] [description] 基层权限组
         * @return {[type]} [description] null
         */
        $scope.secondSelectAll = function(items, Pflag) {
            var flag = angular.isDefined(Pflag) ? Pflag : $scope.secondSelectAllChecked(items);
            var rightValue = $scope.data.manageModuleData[0].RIGHTVALUE.split('');
            for (var i = 0; i < items.CHILDREN.length; i++) {
                rightValue[items.CHILDREN[i].RIGHTINDEX - 1] = flag ? '0' : '1';
            }
            $scope.data.manageModuleData[0].RIGHTVALUE = rightValue.join('');
        };

        /**
         * [firstSelectAll ]一级全选
         * @return {[type]} [description] null
         */
        $scope.firstSelectAll = function() {
            var flag = $scope.firstSelectAllChecked();
            for (var i = 0; i < $scope.data.structuredData.CHILDREN.length; i++) {
                $scope.secondSelectAll($scope.data.structuredData.CHILDREN[i], flag);
            }
        };

        /**
         * [firstSelectAllChecked ]二级全选检查
         * @return {[type]} [description] null
         */
        $scope.firstSelectAllChecked = function() {
            var flag = true;
            for (var i = 0; i < $scope.data.structuredData.CHILDREN.length; i++) {
                if (!$scope.data.structuredData.CHILDREN[i].isSelectedAll) {
                    flag = false;
                    break;
                }
            }
            return flag;
        };

        /**
         * [confirm ]确定
         * @return {[type]} [description] null
         */
        $scope.confirm = function() {
            var data = [];
            data.push(constructData($scope.data.manageModuleData[0]));
            for (var i = 0; i < $scope.data.commonModuleData.length; i++) {
                data.push(constructData($scope.data.commonModuleData[i]));
            }
            for (var i = 0; i < $scope.data.planResources.length; i++) {
                data.push(constructData($scope.data.planResources[i]));
            }
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'saveRight',
                RoleId: $scope.roleData.ROLEID,
                rights: JSON.stringify(data),
            };
            modalDialog.alertType('确定要保存模块可见性授权么？', '', 'ask', true, function() {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                    modalDialog.alertType('模块可见性授权保存成功', '', 'success', false);
                    $state.go('manageconfig.rolemanage.modulevisibility', '', { reload: 'manageconfig.rolemanage.modulevisibility' });
                });
            });
        };

        /**
         * [constructData ]构造数据
         * @return {[type]} [description] null
         */
        function constructData(data) {
            return {
                ID: data.RIGHTID,
                OPRTYPE: '203',
                OPRID: $scope.roleData.ROLEID,
                OBJTYPE: data.OBJTYPE,
                OBJID: data.OBJID,
                NEWVALUE: data.RIGHTVALUE,
            };
        }

        /**
         * [initGroupRight description] 初始化权限ID
         * @param  {[type]} item [description]  权限对象
         * @return {[type]}      [description]
         */
        $scope.initGroupRight = function(item) {
            permissionAssignmentService.initGroupRight(item, $scope.roleData.ROLEID).then(function(data) {
                item.RIGHTID = data;
            });
        };
    },
]);
